export default __webpack_public_path__ + "static/media/DisneyMarvelSpiderman1.3f388099.jpg";